/**
 * PDP Swiper Functionality
 * Handles product detail page image slider with trackpad/mousewheel support
 */

document.addEventListener('DOMContentLoaded', function () {
    // Stored references for prev/next click handlers to avoid duplicate listeners on resize
    var prevClickHandler = null;
    var nextClickHandler = null;

    // Initialize Product Gallery Swiper only on mobile devices
    function initMobileSwiper() {
        if (window.innerWidth <= 768) {
            const productSwiper = document.querySelector(
                '.mySwiper.mobile-slider-only'
            );
            if (productSwiper) {
                // Destroy existing instance so updated params take effect
                if (productSwiper.swiper) {
                    if (productSwiper.swiper.mousewheel) {
                        productSwiper.swiper.mousewheel.disable();
                    }
                    productSwiper.swiper.destroy(true, true);
                }

                // Configure Swiper Element properties before re-initialization
                productSwiper.slidesPerView = 1;
                productSwiper.spaceBetween = 0;
                productSwiper.centeredSlides = false;
                productSwiper.loop = true;
                productSwiper.mousewheel = {
                    forceToAxis: true,
                    releaseOnEdges: true,
                    sensitivity: 0.1,
                    thresholdDelta: 50,
                    thresholdTime: 500
                };

                // (Re-)initialize with the updated settings
                productSwiper.initialize();

                // Wire up custom prev/next buttons (remove old handlers first to avoid duplicates on resize)
                const prevBtn = document.querySelector('.pdp-swiper-button-prev');
                const nextBtn = document.querySelector('.pdp-swiper-button-next');
                if (prevBtn) {
                    if (prevClickHandler) prevBtn.removeEventListener('click', prevClickHandler);
                    if (productSwiper.swiper) {
                        prevClickHandler = function () { productSwiper.swiper.slidePrev(); };
                        prevBtn.addEventListener('click', prevClickHandler);
                    }
                }
                if (nextBtn) {
                    if (nextClickHandler) nextBtn.removeEventListener('click', nextClickHandler);
                    if (productSwiper.swiper) {
                        nextClickHandler = function () { productSwiper.swiper.slideNext(); };
                        nextBtn.addEventListener('click', nextClickHandler);
                    }
                }

            }
        }
    }

    // Initialize on load
    initMobileSwiper();

    // Re-initialize on resize
    window.addEventListener('resize', function () {
        setTimeout(initMobileSwiper, 100);
    });

    // Wrap quantity selector + buy buttons in a flex row
    const quantityBlock = document.querySelector('.product__info-container .product-form__quantity');
    if (quantityBlock) {
        // Find the buy-buttons block by walking siblings
        let buyBlock = null;
        let sibling = quantityBlock.nextElementSibling;
        while (sibling) {
            if (sibling.querySelector('.product-form__buttons')) {
                buyBlock = sibling;
                break;
            }
            sibling = sibling.nextElementSibling;
        }
        if (buyBlock) {
            const wrapper = document.createElement('div');
            wrapper.className = 'quantity-buy-row';
            quantityBlock.parentNode.insertBefore(wrapper, quantityBlock);
            wrapper.appendChild(quantityBlock);
            wrapper.appendChild(buyBlock);
        }
    }

    // Move Klaviyo star rating inline with vendor name
    if (document.body.classList.contains('template-pdp-2026')) {
        var vendor = document.querySelector('.product__text.inline-richtext.label-large');
        var stars = document.querySelector('span.klaviyo-star-rating-widget');
        if (vendor && stars) {
            var row = document.createElement('div');
            row.className = 'vendor-stars-row';
            vendor.parentNode.insertBefore(row, vendor);
            row.appendChild(vendor);
            row.appendChild(stars);
            vendor.style.marginTop = '0';
        }
    }

    // Hide empty accordion rows (only on pdp2026 templates)
    if (document.body.classList.contains('template-pdp-2026')) {
        document.querySelectorAll('.product__accordion .accordion__content.rte').forEach(function (content) {
            var klaviyoReviews = content.querySelector('[data-klaviyo-reviews]');
            var accordionTitle = content.closest('.product__accordion').querySelector('.accordion__title');
            var isSizeGuide = accordionTitle && accordionTitle.textContent.trim().toLowerCase() === 'size guide';
            if (klaviyoReviews && !isSizeGuide) {
                // Show loading text while waiting for Klaviyo widget to be moved in
                var placeholder = document.createElement('p');
                placeholder.style.cssText = 'color: var(--color-gray); font-size: 14px;';
                placeholder.textContent = 'Loading reviews...';
                placeholder.className = 'klaviyo-reviews-placeholder';
                klaviyoReviews.after(placeholder);

                // Poll for the standalone Klaviyo reviews app block and move it into the accordion
                var widgetAttempts = 0;
                var widgetTimer = setInterval(function () {
                    widgetAttempts++;
                    var klaviyoWidget = document.querySelector('[id*="klaviyo_reviews_product_reviews"]');
                    if (!klaviyoWidget) {
                        if (widgetAttempts > 50) {
                            clearInterval(widgetTimer);
                            placeholder.textContent = 'No reviews on this product.';
                        }
                        return;
                    }
                    // Check if widget has content
                    if (klaviyoWidget.children.length === 0) {
                        if (widgetAttempts > 50) {
                            clearInterval(widgetTimer);
                            placeholder.textContent = 'No reviews on this product.';
                        }
                        return;
                    }
                    clearInterval(widgetTimer);
                    placeholder.remove();

                    // Save reference to standalone section BEFORE moving
                    var standaloneSection = klaviyoWidget.closest('.shopify-section');

                    // Move the widget content into the accordion
                    klaviyoReviews.appendChild(klaviyoWidget);

                    // Hide the now-empty standalone section
                    if (standaloneSection) {
                        standaloneSection.style.display = 'none';
                    }
                }, 300);
                return;
            }
            if (content.textContent.trim() === '') {
                content.closest('.product__accordion').style.display = 'none';
            }
        });
    }

    // Handle popup functionality
    const image_popup = document.getElementById('image-popup');
    const closeButton = document.getElementById('close-popup');

    // Open popup when clicking on product images
    const slides = document.querySelectorAll('.mySwiper swiper-slide');
    slides.forEach(function (slide) {
        slide.addEventListener('click', function () {
            if (image_popup) {
                image_popup.classList.remove('hidden-pop');
            }
        });
    });

    // Close popup functionality
    if (closeButton && image_popup) {
        closeButton.addEventListener('click', function () {
            image_popup.classList.add('hidden-pop');
        });
    }

    // Close popup when clicking outside
    if (image_popup) {
        image_popup.addEventListener('click', function (e) {
            if (e.target === image_popup) {
                image_popup.classList.add('hidden-pop');
            }
        });
    }

    // Transform Textify fields into collapsible accordion groups
    // Textify is JS-injected, so we poll until it renders
    if (document.body.classList.contains('template-pdp-2026')) {
        var textifyAttempts = 0;
        var textifyTimer = setInterval(function () {
            textifyAttempts++;
            var textifyApp = document.getElementById('textfieldapp');
            if (!textifyApp) {
                if (textifyAttempts > 50) clearInterval(textifyTimer);
                return;
            }

            // Find ALL combined fields containers
            var allContainers = textifyApp.querySelectorAll('[class*="tb_combinedFields"]');
            if (allContainers.length === 0) {
                if (textifyAttempts > 50) clearInterval(textifyTimer);
                return;
            }

            // Use the first container as the primary one (pet + vet fields)
            var primaryContainer = allContainers[0];
            var fields = primaryContainer.querySelectorAll(':scope > .textbox_combined_fields');
            if (fields.length === 0) {
                if (textifyAttempts > 50) clearInterval(textifyTimer);
                return;
            }

            clearInterval(textifyTimer);

            // Determine grouping by reading label text
            var petFields = [];
            var vetFields = [];

            fields.forEach(function (field) {
                var label = field.querySelector('p[data-fieldname]');
                var labelText = label ? label.textContent.trim().toLowerCase() : '';
                if (labelText.indexOf('vet') !== -1) {
                    vetFields.push(field);
                } else {
                    petFields.push(field);
                }
            });

            // Move the Prescription Information description block above the accordions
            // It lives in a separate tb_combinedFields container
            var descriptionBlock = null;
            for (var i = 1; i < allContainers.length; i++) {
                descriptionBlock = allContainers[i];
            }

            // Build accordion groups
            var groups = [];
            if (petFields.length > 0) groups.push({ title: 'Stage 1: Pet info', fields: petFields });
            if (vetFields.length > 0) groups.push({ title: 'Stage 2: Vet info', fields: vetFields });

            // Clear the primary container and build the new layout
            primaryContainer.innerHTML = '';

            // Insert description block at the top if found
            if (descriptionBlock) {
                descriptionBlock.classList.add('textify-description-block');
                primaryContainer.appendChild(descriptionBlock);
            }

            // Build accordions
            groups.forEach(function (group) {
                var details = document.createElement('details');
                details.className = 'textify-accordion';

                var summary = document.createElement('summary');
                summary.className = 'textify-accordion__summary';
                summary.innerHTML =
                    '<span class="textify-accordion__title">' + group.title + '</span>' +
                    '<span class="textify-accordion__icon textify-accordion__icon--plus">+</span>' +
                    '<span class="textify-accordion__icon textify-accordion__icon--minus">&minus;</span>';

                var content = document.createElement('div');
                content.className = 'textify-accordion__content';

                group.fields.forEach(function (field) {
                    content.appendChild(field);
                });

                details.appendChild(summary);
                details.appendChild(content);
                primaryContainer.appendChild(details);
            });

            // Force textarea styles via JS to beat Textify inline !important
            primaryContainer.querySelectorAll('textarea').forEach(function (ta) {
                ta.style.setProperty('border-radius', '50px', 'important');
                ta.style.setProperty('padding', '0 20px', 'important');
                ta.style.setProperty('height', '52px', 'important');
                ta.style.setProperty('min-height', '52px', 'important');
                ta.style.setProperty('max-height', '52px', 'important');
                ta.style.setProperty('line-height', '52px', 'important');
                ta.style.setProperty('resize', 'none', 'important');
                ta.style.setProperty('width', '100%', 'important');
                ta.style.setProperty('max-width', '100%', 'important');
            });

            // Also force the textfield wrapper divs to full width
            primaryContainer.querySelectorAll('[id*="textFieldDiv"]').forEach(function (div) {
                div.style.setProperty('max-width', '100%', 'important');
                div.style.setProperty('width', '100%', 'important');
            });

            // Disable ATC button until all required Textify fields are filled
            // Textify sets required as a JS property, not an HTML attribute,
            // so we filter textareas by checking the .required property
            var allTextareas = primaryContainer.querySelectorAll('textarea');
            var requiredFields = [];
            allTextareas.forEach(function (ta) {
                if (ta.required) requiredFields.push(ta);
            });
            var atcButton = document.querySelector('.product-form__submit');
            if (requiredFields.length > 0 && atcButton) {
                function checkRequiredFields() {
                    var allFilled = true;
                    requiredFields.forEach(function (field) {
                        if (field.value.trim() === '') {
                            allFilled = false;
                        }
                    });
                    atcButton.disabled = !allFilled;
                    if (allFilled) {
                        atcButton.classList.remove('disabled');
                    } else {
                        atcButton.classList.add('disabled');
                    }
                }
                checkRequiredFields();
                requiredFields.forEach(function (field) {
                    field.addEventListener('input', checkRequiredFields);
                    field.addEventListener('change', checkRequiredFields);
                });
            }
        }, 200);
    }

    // On desktop, move trust badges + collapsible content into the right grid column.
    // On mobile, move them back to their original position.
    // Use placeholder divs to mark original positions so sections can be restored on mobile.
    function moveToInfoWrapper(sectionEl, infoWrapper) {
        if (sectionEl.closest('.product__info-wrapper')) return; // already moved
        // Insert a placeholder where the section currently sits
        if (!sectionEl._pdpPlaceholder) {
            var placeholder = document.createElement('div');
            placeholder.style.display = 'none';
            placeholder.className = 'pdp-section-placeholder';
            sectionEl.parentNode.insertBefore(placeholder, sectionEl);
            sectionEl._pdpPlaceholder = placeholder;
        }
        infoWrapper.appendChild(sectionEl);
    }

    function restoreFromInfoWrapper(sectionEl) {
        if (!sectionEl.closest('.product__info-wrapper')) return; // not moved
        var placeholder = sectionEl._pdpPlaceholder;
        if (placeholder && placeholder.parentNode) {
            placeholder.parentNode.insertBefore(sectionEl, placeholder);
            placeholder.parentNode.removeChild(placeholder);
            sectionEl._pdpPlaceholder = null;
        }
    }

    function moveSectionsToInfoWrapper() {
        if (!document.body.classList.contains('template-pdp-2026')) return;
        var infoWrapper = document.querySelector('.product__info-wrapper');
        if (!infoWrapper) return;

        var trustBadgesSection = document.querySelector('.trust-badges-section');
        var collapsibleSections = document.querySelectorAll('.collapsible-content');

        if (trustBadgesSection) {
            var parent = trustBadgesSection.closest('.shopify-section');
            if (parent) moveToInfoWrapper(parent, infoWrapper);
        }
        collapsibleSections.forEach(function (section) {
            var parent = section.closest('.shopify-section');
            if (parent) moveToInfoWrapper(parent, infoWrapper);
        });
    }

    function restoreSectionsFromInfoWrapper() {
        var trustBadgesSection = document.querySelector('.trust-badges-section');
        var collapsibleSections = document.querySelectorAll('.collapsible-content');

        if (trustBadgesSection) {
            var parent = trustBadgesSection.closest('.shopify-section');
            if (parent) restoreFromInfoWrapper(parent);
        }
        collapsibleSections.forEach(function (section) {
            var parent = section.closest('.shopify-section');
            if (parent) restoreFromInfoWrapper(parent);
        });
    }

    function handleSectionLayout() {
        if (!document.body.classList.contains('template-pdp-2026')) return;
        if (window.innerWidth >= 750) {
            moveSectionsToInfoWrapper();
        } else {
            restoreSectionsFromInfoWrapper();
        }
    }

    // Poll for sections (they may render after DOMContentLoaded)
    if (document.body.classList.contains('template-pdp-2026')) {
        var moveAttempts = 0;
        var moveTimer = setInterval(function () {
            moveAttempts++;
            var infoWrapper = document.querySelector('.product__info-wrapper');
            if (!infoWrapper) {
                if (moveAttempts > 50) clearInterval(moveTimer);
                return;
            }

            handleSectionLayout();

            // On desktop, check if all sections are now inside info wrapper
            if (window.innerWidth >= 750) {
                var trustBadges = document.querySelector('.trust-badges-section');
                var collapsibles = document.querySelectorAll('.collapsible-content');
                var allMoved = true;
                if (trustBadges && !trustBadges.closest('.product__info-wrapper')) allMoved = false;
                collapsibles.forEach(function (s) {
                    if (!s.closest('.product__info-wrapper')) allMoved = false;
                });
                if (allMoved && (trustBadges || collapsibles.length > 0)) {
                    clearInterval(moveTimer);
                }
            } else {
                clearInterval(moveTimer);
            }
            if (moveAttempts > 50) clearInterval(moveTimer);
        }, 200);
    }

    // Re-run on bfcache restore (back/forward navigation)
    window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            handleSectionLayout();
        }
    });

    // Re-run when crossing the 750px breakpoint (e.g. DevTools responsive toggle)
    // Using both matchMedia (reliable for breakpoint changes) and resize (fallback)
    var desktopMQ = window.matchMedia('(min-width: 750px)');
    desktopMQ.addEventListener('change', function () {
        handleSectionLayout();
    });
    var wasDesktop = window.innerWidth >= 750;
    window.addEventListener('resize', function () {
        var isDesktop = window.innerWidth >= 750;
        if (isDesktop !== wasDesktop) {
            handleSectionLayout();
        }
        wasDesktop = isDesktop;
    });

    // Dynamic sticky: apply sticky to the shorter column on desktop
    if (document.body.classList.contains('template-pdp-2026')) {
        function updateStickyColumn() {
            if (window.innerWidth < 750) return;
            var mediaCol = document.querySelector('.product.for-pdp .product__media-wrapper');
            var infoCol = document.querySelector('.product.for-pdp .product__info-wrapper');
            if (!mediaCol || !infoCol) return;

            mediaCol.classList.remove('pdp-sticky-column');
            infoCol.classList.remove('pdp-sticky-column');

            var mediaHeight = mediaCol.scrollHeight;
            var infoHeight = infoCol.scrollHeight;

            if (mediaHeight <= infoHeight) {
                mediaCol.classList.add('pdp-sticky-column');
            } else {
                infoCol.classList.add('pdp-sticky-column');
            }
        }

        // Run after sections are moved and content is loaded
        setTimeout(updateStickyColumn, 1000);
        window.addEventListener('resize', updateStickyColumn);
        // Re-check when images load (can change column height)
        document.querySelectorAll('.product.for-pdp img').forEach(function (img) {
            img.addEventListener('load', updateStickyColumn);
        });
    }

    // Move size guide drawer out of hidden .size-guide-wrapper so it can render
    if (document.body.classList.contains('template-pdp-2026')) {
        var sizeDrawer = document.getElementById('size-guide-drawer');
        var drawerOverlay = document.getElementById('drawer-overlay');
        if (sizeDrawer) document.body.appendChild(sizeDrawer);
        if (drawerOverlay) document.body.appendChild(drawerOverlay);

        // Bind close events for the moved drawer
        var sizeClose = document.getElementById('size-guide-close');
        if (sizeClose && sizeDrawer) {
            sizeClose.addEventListener('click', function () {
                sizeDrawer.classList.remove('active');
                if (drawerOverlay) drawerOverlay.classList.remove('active');
                document.body.style.overflow = '';
            });
        }
        if (drawerOverlay && sizeDrawer) {
            drawerOverlay.addEventListener('click', function () {
                sizeDrawer.classList.remove('active');
                drawerOverlay.classList.remove('active');
                document.body.style.overflow = '';
            });
        }
    }

    // Replace "Size Guide" accordion content with a button that opens the size guide drawer
    if (document.body.classList.contains('template-pdp-2026')) {
        document.querySelectorAll('.product__accordion .accordion__title').forEach(function (title) {
            if (title.textContent.trim().toLowerCase() === 'size guide') {
                var accordion = title.closest('.product__accordion');
                if (!accordion) return;

                // Replace the accordion content with a styled button
                var contentDiv = accordion.querySelector('.accordion__content');
                if (contentDiv) {
                    var btnText = contentDiv.textContent.trim() || 'Open size guide';
                    contentDiv.innerHTML = '';
                    var btn = document.createElement('button');
                    btn.type = 'button';
                    btn.className = 'pdp-size-guide-btn';
                    btn.textContent = btnText;
                    btn.addEventListener('click', function () {
                        var drawer = document.getElementById('size-guide-drawer');
                        var overlay = document.getElementById('drawer-overlay');
                        if (drawer && overlay) {
                            drawer.classList.add('active');
                            overlay.classList.add('active');
                            document.body.style.overflow = 'hidden';
                        }
                    });
                    contentDiv.appendChild(btn);
                }
            }
        });
    }

});
